/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcArrowLeftRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M10.636 6.636a.9.9 0 1 0-1.273-1.272l-6 6a.897.897 0 0 0-.006 1.266l.007.007 6 6a.9.9 0 0 0 1.272-1.273L6.172 12.9H20a.9.9 0 0 0 0-1.8H6.172z" />
    </svg>
  );
}
export default IcArrowLeftRegular;
